module.exports = __webpack_public_path__ + "static/media/puzzle-typography.8878aa40.mp4";